import React from "react";
import { useSelector } from "react-redux";
import { MenuItemLink, getResources, useTranslate } from "react-admin";
import {
  Dashboard,
  Build,
  Home,
  Share,
  AccessTime,
  FormatColorFill,
  Category,
  LocationOn,
  Dns,
} from "@material-ui/icons";
import { Layout } from "react-admin";
import AppBar from "./AppBar";
import { Container, Instagram } from "./styles";
const MyLayout = (props) => {
  return <Layout {...props} menu={Menu} appBar={AppBar} />;
};

const Menu = ({ hasDashboard }) => {
  const translate = useTranslate();

  const open = useSelector((state) => state.admin.ui.sidebarOpen);
  const resources = useSelector(getResources);

  return (
    <Container>
      <MenuItemLink
        to="/home"
        primaryText={translate(`custom.menu.home`)}
        leftIcon={<Home style={{ color: "#fff" }} />}
        sidebarIsOpen={open}
      />
      <MenuItemLink
        to="/configuration"
        primaryText={translate(`custom.menu.configuration`)}
        leftIcon={<Build style={{ color: "#fff" }} />}
        sidebarIsOpen={open}
      />
      <MenuItemLink
        to="/themeEdit"
        primaryText={"Tema"}
        leftIcon={<FormatColorFill style={{ color: "#fff" }} />}
        sidebarIsOpen={open}
      />
      <MenuItemLink
        to="/category"
        primaryText={translate(`custom.menu.category`)}
        leftIcon={<Category style={{ color: "#fff" }} />}
        sidebarIsOpen={open}
      />
      <MenuItemLink
        to="/product"
        primaryText="Produtos"
        leftIcon={<Dns color="#fff" style={{ color: "#fff" }} />}
        sidebarIsOpen={open}
      />
      <MenuItemLink
        to="/opening"
        primaryText={translate(`custom.menu.opening`)}
        leftIcon={<AccessTime style={{ color: "#fff" }} />}
        sidebarIsOpen={open}
      />
      <MenuItemLink
        to="/address"
        primaryText={translate(`custom.menu.address`)}
        leftIcon={<LocationOn style={{ color: "#fff" }} />}
        sidebarIsOpen={open}
      />
      <MenuItemLink
        to="/statistics"
        primaryText="Estatisticas"
        leftIcon={<Dashboard style={{ color: "#fff" }} />}
        sidebarIsOpen={open}
      />
      <MenuItemLink
        to="/qrcode"
        primaryText="Compartilhe"
        leftIcon={<Share color="#fff" style={{ color: "#fff" }} />}
        sidebarIsOpen={open}
      />
      <Instagram>
        Siga nosso instagram <br /> e fique informado <br /> 
        <a href="https://instagram.com/menulegal" target="_blank">
          <img src={require("../../Assets/images/instagram.png")} />
        </a>
      </Instagram>
    </Container>
  );
};

export default MyLayout;
